module.exports = __webpack_public_path__ + "static/media/people.aaf2b669.png";